import { useMutation } from "react-query";
import axios from "axios";

const sendContactUsMessage = async (formData) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/contact-us`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};

const useContactUs = () => {
  return useMutation((formData) => sendContactUsMessage(formData));
};

export default useContactUs;
